import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
import useBrands from "../../hooks/use-brands";
import BaseBrandDialog from "./base-brand-dialog";

const CreateBrandDialog: React.FC<BaseDialogProps> = (props) => {
  const { createBrand } = useBrands();

  return <BaseBrandDialog {...props} actionButtonText="Create" performAction={createBrand} />;
};

export default CreateBrandDialog;
